import Head from "next/head";
import { useRouter } from "next/router";

import classNames from "classnames";

import CustomCard from "components/CustomCard";
import { Tab, Tabs } from "components/Tabs";

import DashboardPageInsightList from "../DashboardPageInsightList";

type DashboardPageTopPicksProps = { showTabs?: boolean };

const DashboardPageTopPicks = ({ showTabs }: DashboardPageTopPicksProps) => {
  const router = useRouter();
  const collection = router.query.collection as string;

  const options =
    collection === "authors-picks"
      ? { filter: { conviction: "1" } }
      : collection === "editors-picks"
      ? { filter: { collection: "editors-picks" } }
      : { filter: { collection: "trending" } };
  const tabContent = (
    <DashboardPageInsightList
      options={{ ...options, showTopPicksToggle: true, showSearch: true }}
    />
  );

  const title = "Trending Insights | Smartkarma";

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta property="og:title" content={title} />
      </Head>
      {showTabs && (
        <Tabs>
          <Tab
            href="/dashboard?collection=authors-picks"
            active={collection === "authors-picks"}
          >
            Author&apos;s Picks
          </Tab>
          <Tab
            href="/dashboard?collection=editors-picks"
            active={collection === "editors-picks"}
          >
            Editor&apos;s Picks
          </Tab>
          <Tab
            href="/dashboard?collection=trending"
            active={collection === "trending"}
          >
            Trending
          </Tab>
        </Tabs>
      )}
      <CustomCard
        className={classNames("p-0", showTabs ? "mt-[15px]" : "mt-[45px]")}
      >
        {tabContent}
      </CustomCard>
    </>
  );
};

export default DashboardPageTopPicks;
